import { render, staticRenderFns } from "./VText.vue?vue&type=template&id=66726f1b&scoped=true"
import script from "./VText.vue?vue&type=script&lang=js"
export * from "./VText.vue?vue&type=script&lang=js"
import style0 from "./VText.vue?vue&type=style&index=0&id=66726f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66726f1b",
  null
  
)

export default component.exports